import React from 'react';

import BandaEnCamino from '../promos/bandaEnCamino';

/*
    Franja «En Camino» de la tarjeta de la matrícula (docs/ESPEC_PROMO_EN_CAMINO.md §4): bajo el acuerdo, la promo viva con su avance
    (lleva / faltan / vence) y, en una línea chica, cómo terminaron las anteriores (Fallida, Cancelada…). Lo manda el Estado de Cuenta en
    `agreementStrip.enCamino` y `agreementStrip.enCaminoHistory`.
*/
interface HistoriaEC { id: number; status: string; statusName: string; promoName: string; endedAt?: string | null; endedReason?: string | null }

const fecha = (d?: string | null) => (d ? d.slice(8, 10) + '/' + d.slice(5, 7) + '/' + d.slice(0, 4) : '');

const FranjaEnCamino: React.FC<{ strip: any }> = ({ strip }) => {
    const vivo = strip && strip.enCamino ? strip.enCamino : null;
    const historia: HistoriaEC[] = ((strip && strip.enCaminoHistory) || []).filter((h: HistoriaEC) => !vivo || Number(h.id) !== Number(vivo.id));
    if (!vivo && !historia.length) return null;
    return (
        <div style={{ marginTop: 8 }}>
            {vivo ? <BandaEnCamino e={vivo} sym={vivo.currencySymbol || ''} style={{ marginTop: 0 }} /> : null}
            {historia.length ? (
                <div style={{ fontSize: 12, color: 'var(--wa-apagado)', marginTop: 4 }}>
                    {historia.map((h) => (
                        <div key={'ech' + h.id}>
                            <b>{h.promoName}</b> {h.statusName}{h.endedAt ? ' ' + fecha(h.endedAt) : ''}{h.endedReason ? ': ' + h.endedReason : ''}
                        </div>
                    ))}
                </div>
            ) : null}
        </div>
    );
};

export default FranjaEnCamino;
